var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampfire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.833 4C16.833 4 10.333 8 10.333 13.5C10.333 15.2239 11.0178 16.8772 12.2368 18.0962C13.4558 19.3152 15.1091 20 16.833 20C16.0374 20 15.2743 19.6839 14.7117 19.1213C14.1491 18.5587 13.833 17.7956 13.833 17C13.833 14 16.833 12 16.833 12C16.833 12 19.833 14 19.833 17C19.833 17.7956 19.5169 18.5587 18.9543 19.1213C18.3917 19.6839 17.6287 20 16.833 20C18.5569 20 20.2102 19.3152 21.4292 18.0962C22.6482 16.8772 23.333 15.2239 23.333 13.5C23.333 8 16.833 4 16.833 4Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 13.5C23.333 15.2239 22.6482 16.8772 21.4292 18.0962C20.2102 19.3152 18.5569 20 16.833 20C15.1091 20 13.4558 19.3152 12.2368 18.0962C11.0178 16.8772 10.333 15.2239 10.333 13.5C10.333 8 16.833 4 16.833 4C16.833 4 23.333 8 23.333 13.5Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 21L27.833 28",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.833 21L5.83301 28",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 17C19.833 17.7956 19.5169 18.5587 18.9543 19.1213C18.3917 19.6839 17.6287 20 16.833 20C16.0374 20 15.2743 19.6839 14.7117 19.1213C14.1491 18.5587 13.833 17.7956 13.833 17C13.833 14 16.833 12 16.833 12C16.833 12 19.833 14 19.833 17Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfire);
export default __webpack_public_path__ + "static/media/Campfire.70558bb543976787f76f2bc2b9e66f69.svg";
export { ForwardRef as ReactComponent };